import { ROTULO_CRITICIDADE_TIS, TEXTOS } from '../../../../lib/glossario'
import type { CampoProponivel } from './proposta'

/**
 * As opções de cada pergunta do julgamento, num lugar só.
 *
 * Existiam duas vezes: nos botões de rádio e, depois, na etiqueta que mostra o que a IA sugeriu.
 * Duas listas com os mesmos rótulos é a receita do sistema anterior — a lista de grupos da
 * contratada estava embutida em duas classes, e um dia elas divergiram. Aqui a divergência seria
 * pior que um bug: a etiqueta diria "sugestão: aceitou parcialmente" ao lado de um botão escrito
 * outra coisa.
 */

const t = TEXTOS.marcacao

export const OPCOES_NATUREZA = [
  { valor: 'CORRETIVA', rotulo: t.natureza.corretiva },
  { valor: 'NAO_CORRETIVA', rotulo: t.natureza.naoCorretiva },
]

export const OPCOES_PRAZO = [
  { valor: 'NO_PRAZO', rotulo: t.prazo.noPrazo },
  { valor: 'FORA_DO_PRAZO', rotulo: t.prazo.foraDoPrazo },
  { valor: 'NAO_SE_APLICA', rotulo: t.prazo.naoSeAplica, ajuda: t.prazo.naoSeAplicaAjuda },
]

export const OPCOES_CONFORMIDADE = [
  { valor: 'CONFORME', rotulo: t.conformidade.conforme },
  { valor: 'INCONFORME', rotulo: t.conformidade.inconforme },
]

export const OPCOES_ACEITE = [
  { valor: 'INTEGRAL', rotulo: t.aceite.integral },
  { valor: 'APOS_TENTATIVAS', rotulo: t.aceite.aposTentativas, ajuda: t.aceite.aposTentativasAjuda },
  { valor: 'PARCIAL', rotulo: t.aceite.parcial },
  { valor: 'SEM_ACEITE', rotulo: t.aceite.semAceite },
  { valor: 'NAO_SE_APLICA', rotulo: t.aceite.naoSeAplica },
]

export const OPCOES_CRITICIDADE = (['ALTA', 'MEDIA', 'BAIXA'] as const).map((nivel) => ({
  valor: nivel,
  rotulo: ROTULO_CRITICIDADE_TIS[nivel] ?? nivel,
}))

const POR_CAMPO: Record<CampoProponivel, { valor: string; rotulo: string }[]> = {
  natureza: OPCOES_NATUREZA,
  prazo: OPCOES_PRAZO,
  criticidade: OPCOES_CRITICIDADE,
  conformidade: OPCOES_CONFORMIDADE,
  aceite: OPCOES_ACEITE,
}

/**
 * O rótulo de um valor, como o botão de rádio o escreve.
 *
 * @param campo qual pergunta
 * @param valor o valor no vocabulário do formulário
 * @returns a frase que o usuário lê, ou o próprio valor se ele não estiver na lista
 */
export function rotuloDoValor(campo: CampoProponivel, valor: string): string {
  return POR_CAMPO[campo].find((opcao) => opcao.valor === valor)?.rotulo ?? valor
}
